import * as Sentry from '@sentry/vue'
import type { App, InjectionKey } from 'vue'
import { env } from '@shared/config/env'

interface LogExceptionOptions {
  trackError?: boolean
  message?: string
  messageType?: 'success' | 'warning' | 'info' | 'error'
}

export interface LogExceptionFunction {
  (err: unknown, options?: LogExceptionOptions): void
}

const isProd = env.isProduction

export const logExceptionKey: InjectionKey<LogExceptionFunction> =
  Symbol('logException')

export default {
  install: (app: App) => {
    const logException: LogExceptionFunction = function logException(
      err: unknown,
      {
        trackError = true,
        message,
        messageType = 'error'
      }: LogExceptionOptions = {}
    ): void {
      app.config.globalProperties.$log.error(err)

      if (isProd && trackError) {
        try {
          Sentry.captureException(err)
        } catch (error) {
          app.config.globalProperties.$log.error('Sentry not available', error)
        }
      }

      if (message) {
        app.config.globalProperties.$message({
          type: messageType,
          message
        })
      }
    }

    app.config.globalProperties.$logException = logException
    app.provide(logExceptionKey, logException)
    app.provide('message', app.config.globalProperties.$message)
  }
}
